import {
  AUTH_RESET,
  AUTH_UPDATE,
  AUTH_SET,
  AUTH_LOGIN,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_SIGNOUT_FAILURE,
  AUTH_LOADING,
  AUTH_SET_LOADING,
  AUTH_SET_ERROR,
  AUTH_SIGNUP,
  AUTH_ERROR,
} from "../actionTypes";

const INITIAL_STATE = {
  auth: {
    email: "",
    isLoggedIn: false,
  },
  loading: false,
  error: null,
};

export default function AuthReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case AUTH_LOGIN:
    case AUTH_LOADING:
      return { ...state, loading: true, error: null };
    case AUTH_SET:
      return { ...state, auth: action.payload, loading: false };
    case AUTH_LOGIN_SUCCESS:
      return { ...state, auth: action.payload, error: null, loading: false };
    case AUTH_UPDATE: {
      const { prop, value } = action.payload;
      return { ...state, auth: { ...state.auth, [prop]: value } };
    }
    case AUTH_ERROR:
    case AUTH_LOGIN_FAILURE:
    case AUTH_SIGNOUT_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case AUTH_SET_LOADING:
      return { ...state, loading: action.payload };
    case AUTH_SET_ERROR:
      return { ...state, error: action.payload };
    case AUTH_RESET:
      return INITIAL_STATE;
    default:
      return state;
  }
}
